import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuscaService {

  baseUrl = environment.baseUrl;

  constructor() { }

  removerAcentos(texto: string): string {
    return texto.normalize("NFD").replace(/[^a-zA-Z0-9]/g, '');
  }

  search<T>(pesquisa: string, lista: T[], parametrosPesquisa: string[]): T[] {
    if(!pesquisa) {
      return lista
    }
    return lista.filter(item => {
        for (const parametro of parametrosPesquisa) {
          if ((item as any)[parametro] && 
          this.removerAcentos((item as any)[parametro]).toString().toLowerCase().includes(this.removerAcentos(pesquisa.toLowerCase()))) {
            return true;
          }
        }
        return false
      }
    );
  }
}
